import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { FlightDetail } from '../../../types/flyingPage';
import { Restore } from '@material-ui/icons';
import { FlightExplorerIcon } from '../icons/FlightExplorerIcon';
import { GREY } from '../styles/constants';
import { useHistory } from 'react-router-dom';
import { FlyingSpiderTxtIcon } from '../icons/FlyingSpiderTxtIcon';
import { FlyingAircraftIcon } from '../icons/FlyingAircraftIcon';

interface ExpandedFlightDetailHeaderProps {
  flightDetail: FlightDetail;
  flightActive: boolean;
}

const getFlightHistoryUrl = (aircraftId: string) => {
  const end = Math.floor(Date.now() / 1000);
  const start = Math.floor((Date.now() - 1000 * 60 * 60 * 24 * 90) / 1000);

  return `/history?end=${end}&start=${start}&aircraftIds=${aircraftId}&`;
};

const getFlightExplorerUrl = (flightDetail: FlightDetail) => {
  return `/history/${flightDetail.track.imei}${flightDetail.track.indexTime}/flight-explorer`;
};

const COLUMN_FLEX_STYLE = { display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' };

export const ExpandedFlightDetailHeader: React.FC<ExpandedFlightDetailHeaderProps> = ({
  flightDetail,
  flightActive
}) => {
  const aircraftId = flightDetail.aircraftId;

  const history = useHistory();

  return (
    <Row>
      <Col offset={3} span={11}>
        <Row style={{ fontSize: '1.1em' }}>
          {flightDetail.aircraft.registration.length > 11 ? (
            <Tooltip placement="right" title={flightDetail.aircraft.registration} trigger="hover">
              <b>{flightDetail.aircraft.registration.substring(0, 11)}...</b>
            </Tooltip>
          ) : (
            <b>{flightDetail.aircraft.registration}</b>
          )}
        </Row>
      </Col>
      <Col offset={0} span={10}>
        <Row type="flex" justify="end" align="bottom" style={{ gap: '4px' }}>
          <Col style={COLUMN_FLEX_STYLE}>
            <Restore
              style={{
                height: '26px',
                width: '26px',
                paddingBottom: '2px'
              }}
              onClick={e => {
                e.stopPropagation();
                history.push(getFlightHistoryUrl(flightDetail.aircraftId));
              }}
            />
          </Col>
          <Col style={{ ...COLUMN_FLEX_STYLE, paddingBottom: '1px' }}>
            <FlightExplorerIcon
              colour="#1890FF"
              height={14}
              width={14}
              viewBox="-2 -0.5 21 20"
              onClick={e => {
                e.stopPropagation();
                history.push(getFlightExplorerUrl(flightDetail));
              }}
            />
          </Col>
          {flightActive && (
            <Col style={{ ...COLUMN_FLEX_STYLE, paddingLeft: '2px' }}>
              <FlyingSpiderTxtIcon
                enabled={!!flightDetail.track.aircraft.activeDeviceConnection}
                userDisplayName={
                  flightDetail.track.aircraft.activeDeviceConnection
                    ? flightDetail.track.aircraft.activeDeviceConnection.user?.displayName
                    : undefined
                }
              />
            </Col>
          )}
          <Col style={{ ...COLUMN_FLEX_STYLE, marginLeft: '-5px' }}>
            <FlyingAircraftIcon aircraftId={aircraftId} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
